<template>
  <img src="../../../assets/img/avatars/avatar5.jpg" alt="avatar5">
</template>
